import { PaneRendererClusters, } from '../../renderers/clusters-renderer';
import { BarsPaneViewBase } from './bars-pane-view-base';
export class SeriesClustersPaneView extends BarsPaneViewBase {
    constructor() {
        super(...arguments);
        this._internal__renderer = new PaneRendererClusters();
    }
    _internal__createRawItem(time, bar, colorer) {
        return Object.assign(Object.assign(Object.assign({}, this._internal__createDefaultItem(time, bar, colorer)), colorer._internal_barStyle(time)), { _internal_trades: (bar === null || bar === void 0 ? void 0 : bar._internal_trades) || [] });
    }
    _internal__prepareRendererData() {
        const clusterStyleProps = this._internal__series._internal_options();
        this._internal__renderer._internal_setData({
            _internal_bars: this._internal__items,
            _internal_barSpacing: this._internal__model._internal_timeScale()._internal_barSpacing(),
            _internal_wickVisible: clusterStyleProps.wickVisible,
            _internal_borderVisible: clusterStyleProps.borderVisible,
            _internal_visibleRange: this._internal__itemsVisibleRange,
        });
    }
}
